import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import { destroy, put } from '../modules/user'
import { isAdmin } from 'helpers/auth'

import component from 'components/Users/Edit'

const mapActionCreators = {
  onSubmit: put,
  handleDelete: destroy // NOTE: this cannot be named destroy as reduxForm uses that..
}

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(mapActionCreators, dispatch),
  dispatch
})

const mapStateToProps = (state) => {
  let obj = {
    user: state.user,
    customers: state.customers,
    initialValues: Object.assign({}, { customers: [] }, state.user)
  }

  obj.initialValues.customers = obj.initialValues.customers.filter(o => o && o.id)
  obj.initialValues.customers.push({ id: undefined })

  return obj
}

const form = reduxForm({
  form: 'edit-user',
  fields: [
    'id', 'email', 'password', 'timezone', 'rollover_offset', 'customers[].id', 'is_admin', 'can_special_order', 'send_order_confirmations'
  ],
  touchOnChange: true,
  validate (state) {
    var errors = {}

    if (state.password && state.password.length < 6) {
      errors.password = 'Your password must be at least 6 characters long.'
    }

    if (isAdmin() && !state.is_admin) { // WARNING: isAdmin() may not be valid at all times..
      let isValid = (state.customers || []).some(customer => {
        if (customer && customer.id) return true
      })

      if (!isValid) errors._error = 'Users must have a customer associated with them.'
    }

    return errors
  }
})(component)

export default connect(mapStateToProps, mapDispatchToProps)(form)



// WEBPACK FOOTER //
// ./src/routes/Users/containers/EditUserContainer.js